import React from 'react';
import propTypes from 'prop-types';
export const UserCardIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 14 14"
      role="img"
      focusable="false"
      ariaHidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m 12,2.333335 -10,0 c -0.5520833,0 -1,0.44791 -1,1 l 0,7.33333 c 0,0.55208 0.4479167,1 1,1 l 10,0 c 0.552083,0 1,-0.44792 1,-1 l 0,-7.33333 c 0,-0.55209 -0.447917,-1 -1,-1 z m -7.3333333,2 C 5.4020833,4.333335 6,4.931245 6,5.666665 c 0,0.73542 -0.5979167,1.33333 -1.3333333,1.33333 -0.7354167,0 -1.3333334,-0.59791 -1.3333334,-1.33333 0,-0.73542 0.5979167,-1.33333 1.3333334,-1.33333 z M 7,9.266665 c 0,0.22083 -0.2083333,0.4 -0.4666667,0.4 l -3.7333333,0 c -0.2583333,0 -0.4666667,-0.17917 -0.4666667,-0.4 l 0,-0.4 c 0,-0.6625 0.6270834,-1.2 1.4,-1.2 l 0.1041667,0 c 0.25625,0.10625 0.5354167,0.16667 0.8291667,0.16667 0.29375,0 0.575,-0.0604 0.8291666,-0.16667 l 0.1041667,0 c 0.7729167,0 1.4,0.5375 1.4,1.2 l 0,0.4 z m 4.666667,-1.1 c 0,0.0917 -0.075,0.16667 -0.166667,0.16667 l -3,0 c -0.091667,0 -0.1666667,-0.075 -0.1666667,-0.16667 l 0,-0.33333 c 0,-0.09167 0.075,-0.16667 0.1666667,-0.16667 l 3,0 c 0.09167,0 0.166667,0.075 0.166667,0.16667 l 0,0.33333 z m 0,-1.33333 c 0,0.0917 -0.075,0.16666 -0.166667,0.16666 l -3,0 c -0.091667,0 -0.1666667,-0.075 -0.1666667,-0.16666 l 0,-0.33334 c 0,-0.0917 0.075,-0.16666 0.1666667,-0.16666 l 3,0 c 0.09167,0 0.166667,0.075 0.166667,0.16666 l 0,0.33334 z m 0,-1.33334 c 0,0.09167 -0.075,0.16667 -0.166667,0.16667 l -3,0 c -0.091667,0 -0.1666667,-0.075 -0.1666667,-0.16667 l 0,-0.33333 c 0,-0.0917 0.075,-0.16667 0.1666667,-0.16667 l 3,0 c 0.09167,0 0.166667,0.075 0.166667,0.16667 l 0,0.33333 z" />
    </svg>
  );
};
UserCardIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
UserCardIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
